<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(login)" class="px-8 pt-2 pb-6 w-full relative">
      <div class="flex flex-col">
        <ValidationProvider rules="required|email" v-slot="{ errors }">
          <label class="font-bold" :for="$t('Forms.email')">
            {{ $t("Forms.email") }}
          </label>
          <input type="email" v-model="formLogin.Username" :class="[errorLogin.username && 'border-newxcaret-red']"
            :placeholder="$t('Forms.email')" :name="$t('Forms.email')" class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                    " />
          <p class="txt-error text-red text-xs italic mb-2">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <p class="txt-error text-red text-xs italic" v-if="errorLogin.username">
          {{ responseErrors.Username[0] }}
        </p>

        <ValidationProvider rules="required" v-slot="{ errors }">
          <label class="font-bold" :for="$t('Forms.password')">
            {{ $t("Forms.password") }}
          </label>
          <input type="password" v-model="formLogin.Password" :class="[errorLogin.password && 'border-newxcaret-red']"
            :placeholder="$t('Forms.password')" :name="$t('Forms.password')" class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                    " />
          <p class="txt-error text-red text-xs italic mb-1">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <p class="txt-error text-red text-xs italic mb-4" v-if="errorLogin.password">
          {{ responseErrors.Password[0] }}
        </p>

        <p class="text-red text-xs italic mb-4" v-if="msgApi.error">
          {{ msgApi.message }}
        </p>

        <div class="flex justify-between p-2">
          <div>
            &nbsp;
          </div>

          <a :title="$t('Forms.forgot_password')" class="cursor-pointer text-link-blue"
            @click.prevent="setModalAuth(6)">{{ $t("Forms.forgot_password") }}</a>
        </div>

        <div class="flex justify-center">
          <button type="submit" :disabled="loading" class="
                      w-full
                      text-center
                      uppercase
                      p-2
                      bg-green-xcaret
                      text-white
                      rounded-full
                      my-2
                      text-sm
                      tracking-wider
                    ">
            {{ $t("Forms.login") }}
          </button>
        </div>
      </div>
    </form>

    <p class="with-line text-center">
      <span class="bg-white">
        {{ $t("Forms.are_you_new") }}</span>
    </p>

    <div class="flex flex-col justify-center px-8 py-4">
      <a :title="$t('Forms.sign_in')" class="
                  cursor-pointer
                  w-full
                  text-center
                  uppercase
                  p-2
                  border border-newxcaret-blue
                  bg-white
                  text-newxcaret-blue
                  rounded-full
                  my-4
                  text-sm
                  tracking-wider
                " @click.prevent="setModalAuth(2)">{{ $t("Forms.sign_in") }}</a>

      <p class="text-xs text-grey font-semibold" v-html="$t('Forms.terms_of_use')"></p>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@components/validators/index.js";
// Cargamos el archivo para las traducciones
import i18n from "@/i18n.js";
import methodUser from "@mixins/methodUser.js";

import Users from "@mixins/Users.js";
import AlbumsMix from "@mixins/albums/GetAlbumsByEmail.js";
import SearchPackage from "@components/photo/searchPackageComponent.vue";
import loginData from "@logic/profile/login.js";

// Models
import User from '@models/User.js';

export default {
  props: [],
  mixins: [methodUser, Users, AlbumsMix],
  components: {
    SearchPackage,
  },
  data: () => ({
    loading: false,
    formLogin: {
      Username: "",
      Password: "",
    }
  }),
  watch: {
    activeForm: function () {
      this.errorLogin.statusApiMessage = false;
      this.msgApi.success = false;
      this.msgApi.error = false;
      this.disableAllInputs();
    },
  },
  computed: {
    // Acceder al state de 'auth' module
    ...mapState('auth', ['modalAuth', 'user']),

    // Usar getters de 'auth' module
    ...mapGetters('auth', ['getModalAuth', 'getUser']),
  },
  methods: {
    // Usar acciones de 'auth' module
    ...mapActions('auth', ['setModalAuth', 'setUser']),
    /**
     * Método para iniciar sesión
     * @returns {Promise<void>}
     */
    async login() {
      try {
        this.$store.dispatch("setLoading", true);
        // POST request using axios
        let response = await loginData.get(this.formLogin);
        this.msgApi.error = false;
        this.msgApi.message = "";

        //Usuario creado pero no activado
        if (response?.data?.userData?.emailVerified === false) {
          this.$store.dispatch("setModalLogin", true);
          this.setUser({ email: response.data.userData.email});
          this.setModalAuth(3);
          Vue.$toast.open({
            message: response?.data?.MESSAGE,
            type: "warning",
          });

          return;
        }

        //Usuario autenticado
        if (response?.data?.access === true) {
          this.$store.dispatch('setUserEmail', this.formLogin.Username);
          this.setUserLoggedIn(response.data.access == true ? true : false);
          this.$store.dispatch("setUserGuest", false);
          this.$store.dispatch("setModalLogin", false);
          this.setUser({
            email: response.data.userData.email,
            firstName: response.data.userData.firstname,
            lastName: response.data.userData.lastname
          });
          await this.getAlbumsByEmail();

          return;
        } 

        //Usuario no autenticado
        if (response?.data?.SUCCESS == "false" && response?.data?.MESSAGE) {
          this.msgApi.error = true;
          this.msgApi.message = response.data.MESSAGE;
          Vue.$toast.open({
            message: response?.data?.MESSAGE,
            type: "error",
          });
        }
      } catch (error) {
        this.$store.dispatch("setLoading", false);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    }
  },
  mounted() { this.formLogin.Username = this.getUser?.Email; },
};
</script>